var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlipMarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 10,
    width: 20,
    height: 36,
    rx: 10,
    fill: "#F05941"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 20,
    height: 36,
    rx: 10,
    fill: "#F3EFE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlipMarkDark);
export default __webpack_public_path__ + "static/media/slip-mark-dark.5e5838dd6300273f4eccb2e1d0dd7963.svg";
export { ForwardRef as ReactComponent };